import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isMobile
}

// Enhanced responsive hook
export function useResponsive() {
  const [breakpoint, setBreakpoint] = React.useState<'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl'>('md')
  
  // Individual boolean flags for common use cases
  const isMobile = breakpoint === 'xs' || breakpoint === 'sm'
  const isTablet = breakpoint === 'md'
  const isDesktop = breakpoint === 'lg' || breakpoint === 'xl' || breakpoint === '2xl' || breakpoint === '3xl'
  
  // Specific breakpoint checks
  const isAtLeast = (minBreakpoint: string) => { /* logic */ }
  const isAtMost = (maxBreakpoint: string) => { /* logic */ }
  
  return {
    breakpoint,
    isMobile,
    isTablet, 
    isDesktop,
    isAtLeast,
    isAtMost,
    // Backward compatibility
  }
}
